import React from 'react'

/** The thumbtack after a pinned folder's name. */
export const PinMark: React.FC = () => (
  <i
    className='fas fa-thumbtack ob-file-pin-mark'
    role='img'
    aria-label='Pinned'
    title='Pinned'
    data-testid='pinned-mark'
  />
)

/**
 * A pinned folder's name, followed by the thumbtack. The two take the name's place in the cell, so
 * the mark sits right after the name and anything after it stays where it was.
 */
export const PinnedName: React.FC<{pinned: boolean; children: React.ReactNode}> = ({
  pinned,
  children,
}) =>
  pinned ? (
    <div className='ob-file-name-pinned'>
      {children}
      <PinMark />
    </div>
  ) : (
    <>{children}</>
  )
